import { useState } from 'react';
import { Box, Center, Table, TableContainer, Tbody, Td, Th, Tr } from '@chakra-ui/react';

import { Header } from '../../../components/header/Header';
import { useComplementaryWithdrawalBenefit } from '../../../hooks/banks/bmg/useComplementaryWithdrawalBenefit';
import { formatCurrency } from '../../../helpers/formatter';
import { CpfForm } from '../../../components/cpf-form/CpfForm';
import { PageTitle } from '../../../components/pageTitle/PageTitle';
import { AlertMessage } from '../../../components/alert-error-message/AlertMessage';

export const ComplementaryWithdrawalBenefit = () => {
  const { loading, getComplementaryWithdrawalBenefit } = useComplementaryWithdrawalBenefit();
  const [errorMessage, setErrorMessage] = useState(null);
  const [complementaryWithdrawalBenefit, setComplementaryWithdrawalBenefit] = useState(null);

  const onClickCpf = async (response) => {
    setErrorMessage(null);
    setComplementaryWithdrawalBenefit(null);
    const { cpf, message } = response;

    if (message) {
      setErrorMessage(message);
    } else {
      const result = await getComplementaryWithdrawalBenefit(cpf);

      if (result.errorMessage) {
        setErrorMessage(result.errorMessage);
      } else {
        setComplementaryWithdrawalBenefit(result);
      }
    }
  }

  const renderingTable = () => {
    if (errorMessage) return <AlertMessage status="error" alertTitle="Error:" message={ errorMessage } />

    if (!complementaryWithdrawalBenefit) return null;

    return (
      <Center>
        <Box marginY='7'>
          <Box padding='3' border='1px' borderColor='gray.200' borderTopRadius="10px">
            CPF Consultado: {complementaryWithdrawalBenefit.cpf}
          </Box>
          <TableContainer>
            <Table variant='simple'>
              <Tbody>
                <Tr>
                  <Th>Entidade</Th>
                  <Th>Matrícula</Th>
                  <Th>Número do cartão</Th>
                  <Th>Limite do cartão</Th>
                  <Th>Limite disponível</Th>
                  <Th>Saque máximo</Th>
                  <Th>Margem Averbada</Th>
                </Tr>
                <Tr>
                  <Td>{ complementaryWithdrawalBenefit.entity }</Td>
                  <Td>{ complementaryWithdrawalBenefit.register }</Td>
                  <Td>{ complementaryWithdrawalBenefit.cardNumber }</Td>
                  <Td>{ formatCurrency(complementaryWithdrawalBenefit.cardLimit) }</Td>
                  <Td>{ formatCurrency(complementaryWithdrawalBenefit.availableLimit) }</Td>
                  <Td>{ formatCurrency(complementaryWithdrawalBenefit.maximumWithdraw) }</Td>
                  <Td>{ formatCurrency(complementaryWithdrawalBenefit.marginValue) }</Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      </Center>
    );
  }

  return (
    <>
      <Header />
      <PageTitle title="Consultar Saque Complentar Benefício" />
      <CpfForm loading={ loading } onClickCpf={ onClickCpf } />
      { renderingTable() }
    </>
  );
}
